import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Col,
  Row,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  UncontrolledTooltip,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { getPageUrl } from '../../../helpers/PageSections';

import ErrorBoundary from '../../ErrorBoundary';

class AdminPageEditMainEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      linkCopied: false,
    };

    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.copyLink = this.copyLink.bind(this);
  }

  handleKeyPress(e) {
    const { handleSave } = this.props;
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSave();
    }
  }

  copyLink() {
    this.setState({ linkCopied: true });
    setTimeout(() => {
      this.setState({ linkCopied: false });
    }, 2000);
  }

  render() {
    const {
      intl,
      page,
      errors,
      responseErrors,
      handleChange,
    } = this.props;
    const { linkCopied } = this.state;

    return (
      <ErrorBoundary>
        <div className="tab-content-wrapper">
          <div className="custom-page-profile">
            <div className="custom-page-details">
              <Row form>
                <Col>
                  <FormGroup>
                    <Label for="inpPageName">
                      {intl.formatMessage({ defaultMessage: 'Name' })}
                    </Label>
                    <Input
                      type="text"
                      name="name"
                      id="inpPageName"
                      placeholder={intl.formatMessage({ defaultMessage: 'Content Portal name' })}
                      defaultValue={page.name}
                      onChange={handleChange}
                      onKeyPress={this.handleKeyPress}
                      invalid={errors.includes('name') || responseErrors['page.name']}
                    />
                    {errors.includes('name') && (
                      <FormFeedback>
                        {intl.formatMessage({ defaultMessage: 'This field is required' })}
                      </FormFeedback>
                    )}
                    {responseErrors['page.name'] && (
                      <FormFeedback>{responseErrors['page.name']}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label for="inpPageUrl">
                      URL
                      <span className="page-url-actions">
                        <a
                          id="open-page"
                          href={getPageUrl(page)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="far fa-external-link" />
                        </a>
                        <UncontrolledTooltip target="open-page">
                          {intl.formatMessage({ defaultMessage: 'Open page' })}
                        </UncontrolledTooltip>
                        {' '}
                        <CopyToClipboard
                          text={getPageUrl(page, true)}
                          options={{
                            format: 'text/plain',
                          }}
                          onCopy={this.copyLink}
                        >
                          {linkCopied ? (
                            <Fragment>
                              {intl.formatMessage({ defaultMessage: 'Copied' })}
                            </Fragment>
                          ) : (
                            <>
                              <a
                                id="copy-page-url"
                                href="#copy"
                                onClick={(e) => { e.preventDefault(); }}
                              >
                                <i className="far fa-copy" />
                              </a>
                              <UncontrolledTooltip target="copy-page-url">
                                {intl.formatMessage({ defaultMessage: 'Copy link' })}
                              </UncontrolledTooltip>
                            </>
                          )}
                        </CopyToClipboard>
                      </span>
                    </Label>
                    <Input
                      type="text"
                      name="url"
                      id="inpPageUrl"
                      placeholder={intl.formatMessage({ defaultMessage: 'Content Portal URL' })}
                      value={page.url}
                      onChange={handleChange}
                      onKeyPress={this.handleKeyPress}
                      invalid={errors.includes('url') || responseErrors['page.url']}
                    />
                    {errors.includes('url') && (
                      <FormFeedback>
                        {intl.formatMessage({ defaultMessage: 'This field is required' })}
                      </FormFeedback>
                    )}
                    {responseErrors['page.url'] && (
                      <FormFeedback>{responseErrors['page.url']}</FormFeedback>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

AdminPageEditMainEdit.propTypes = {
  intl: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  responseErrors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default injectIntl(AdminPageEditMainEdit);
